/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BackgroundCheckDetail_backgroundCheck = {
    readonly uuid: string;
    readonly createdAt: string;
    readonly approvalDate: string | null;
    readonly expiresAt: string | null;
    readonly applicationSentAt: string | null;
    readonly applicationReceivedAt: string | null;
    readonly requestedDBS: boolean;
    readonly onlyDBS: boolean;
    readonly hasAllResponses: boolean;
    readonly idExpiryDate: string | null;
    readonly dbsExpiryDate: string | null;
    readonly isRenewal: boolean;
    readonly isVerification: boolean;
    readonly isCAA: boolean;
    readonly interviewNotes: {
        readonly yourName: string;
        readonly employmentDecider: string;
    } | null;
    readonly interviewNotesSendLogs: ReadonlyArray<{
        readonly sentAt: string;
        readonly emailAddress: string;
    }>;
    readonly delegate: {
        readonly uuid: string;
        readonly firstName: string;
        readonly lastName: string;
        readonly email: string | null;
    };
    readonly history: ReadonlyArray<{
        readonly uuid: string;
        readonly isArchived: boolean;
        readonly responseSendLogs: ReadonlyArray<{
            readonly emailAddress: string;
            readonly sentAt: string;
        }>;
        readonly employer: {
            readonly uuid: string;
            readonly application: {
                readonly uuid: string;
                readonly name: string;
                readonly contactEmail: string;
                readonly jobTitle: string;
                readonly dates: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
            readonly response: {
                readonly uuid: string;
                readonly orgName: string;
                readonly orgContactName: string;
                readonly datesEmployed: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
        } | null;
        readonly education: {
            readonly uuid: string;
            readonly application: {
                readonly uuid: string;
                readonly name: string;
                readonly contactEmail: string;
                readonly dates: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
            readonly response: {
                readonly uuid: string;
                readonly orgName: string;
                readonly orgContactName: string;
                readonly dates: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
        } | null;
        readonly selfEmployed: {
            readonly uuid: string;
            readonly application: {
                readonly uuid: string;
                readonly accountantName: string;
                readonly contactEmail: string;
                readonly dates: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
            readonly response: {
                readonly uuid: string;
                readonly orgName: string;
                readonly orgContactName: string;
                readonly dates: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
        } | null;
        readonly unemployed: {
            readonly uuid: string;
            readonly application: {
                readonly uuid: string;
                readonly dates: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
            readonly response: {
                readonly uuid: string;
                readonly alternateDates: ReadonlyArray<{
                    readonly startDate: string;
                    readonly endDate: string;
                }>;
            } | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"Timeline_history">;
    }> | null;
    readonly " $refType": "BackgroundCheckDetail_backgroundCheck";
};
export type BackgroundCheckDetail_backgroundCheck$data = BackgroundCheckDetail_backgroundCheck;
export type BackgroundCheckDetail_backgroundCheck$key = {
    readonly " $data"?: BackgroundCheckDetail_backgroundCheck$data;
    readonly " $fragmentRefs": FragmentRefs<"BackgroundCheckDetail_backgroundCheck">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "uuid",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "sentAt",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "emailAddress",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contactEmail",
        "args": null,
        "storageKey": null
    } as any), v5 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "startDate",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "endDate",
            "args": null,
            "storageKey": null
        } as any)
    ], v6 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "dates",
        "storageKey": null,
        "args": null,
        "concreteType": "HistoryDates",
        "plural": true,
        "selections": (v5 /*: any*/)
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgName",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "orgContactName",
        "args": null,
        "storageKey": null
    } as any), v9 = [
        (v0 /*: any*/),
        (v7 /*: any*/),
        (v8 /*: any*/),
        (v6 /*: any*/)
    ];
    return {
        "kind": "Fragment",
        "name": "BackgroundCheckDetail_backgroundCheck",
        "type": "BackgroundCheck",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "approvalDate",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "expiresAt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "applicationSentAt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "applicationReceivedAt",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "requestedDBS",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "onlyDBS",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasAllResponses",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "idExpiryDate",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "dbsExpiryDate",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isRenewal",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isVerification",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isCAA",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "interviewNotes",
                "storageKey": null,
                "args": null,
                "concreteType": "InterviewNotes",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "yourName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "employmentDecider",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "interviewNotesSendLogs",
                "storageKey": null,
                "args": null,
                "concreteType": "InterviewNotesLog",
                "plural": true,
                "selections": [
                    (v1 /*: any*/),
                    (v2 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "delegate",
                "storageKey": null,
                "args": null,
                "concreteType": "Delegate",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "history",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundHistory",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isArchived",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "responseSendLogs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ResponseSendLog",
                        "plural": true,
                        "selections": [
                            (v2 /*: any*/),
                            (v1 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "employer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundHistoryEmployer",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "application",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckEmployerApplication",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "jobTitle",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v6 /*: any*/)
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "response",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckEmployerResponse",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v7 /*: any*/),
                                    (v8 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "datesEmployed",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "HistoryDates",
                                        "plural": true,
                                        "selections": (v5 /*: any*/)
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "education",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundHistoryEducation",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "application",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckEducationApplication",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v3 /*: any*/),
                                    (v4 /*: any*/),
                                    (v6 /*: any*/)
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "response",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckEducationResponse",
                                "plural": false,
                                "selections": (v9 /*: any*/)
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "selfEmployed",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundHistorySelfEmployed",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "application",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckSelfEmployedApplication",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "accountantName",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v4 /*: any*/),
                                    (v6 /*: any*/)
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "response",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckSelfEmploymentResponse",
                                "plural": false,
                                "selections": (v9 /*: any*/)
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "unemployed",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BackgroundHistoryUnemployed",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "application",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckUnemployedApplication",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v6 /*: any*/)
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "response",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BackgroundCheckUnemployedResponse",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "alternateDates",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "HistoryDates",
                                        "plural": true,
                                        "selections": (v5 /*: any*/)
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Timeline_history",
                        "args": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '02297497dae12eb89a1b5ee469b00e59';
export default node;
